<template>
  <section
    class="addedtobag-summary font-responsive-body p-b-18 p-b-lg-24"
    :style="style"
  >
    <div v-if="cartItems.length">
      <div class="m-t-18">
        {{
          replaceAndInsert(
            "value",
            cartCount,
            "Payment",
            cartCount > 1 ? "ItemsInTheBag" : "ItemInTheBag"
          )
        }}
      </div>
      <div class="-devider" />
      <!-- TOTAL -->
      <div class="d-flex justify-content-between">
        <div class="label -ellipsis">
          {{ insertString("Payment", "SubTotal") }}
        </div>
        <div class="value -ellipsis">{{ outputTotalExclShipping }}</div>
      </div>
      <!-- SHIPPING -->
      <div class="d-flex justify-content-between m-t-6">
        <div class="label -ellipsis">
          {{ insertString("Global", "Bag", "Shipping") }}
        </div>
        <div class="value -ellipsis">{{ outputShipping }}</div>
      </div>
      <div class="font-responsive-small flex-wrap m-t-3 -gray-dark">
        {{
          replaceAndInsert(
            "estimate",
            ShippingTimeEstimate,
            "Payment",
            "EstimateDelivery"
          )
        }}
      </div>
      <div class="-devider" />
      <div class="-bold d-flex justify-content-between">
        <div class="label -ellipsis">
          {{ insertString("Global", "Bag", "Total") }}
        </div>
        <div class="value">{{ outputTotal }}</div>
      </div>
      <div class="-devider" />
      <div class="grid-2 m-t-18 m-b-lg-21 -small-gap">
        <ButtonComponent
          class="g-"
          theme="main"
          :block="true"
          :href="bagUrl"
          :text="insertString('Global', 'Bag', 'GoToBag')"
          :overrideThemeColor="Globals.colors.blueDark"
        />
      </div>
    </div>
  </section>
</template>

<script>

import ButtonComponent from '@/Scripts/components/shared/ButtonV2/ButtonV2.vue';
import { mapState, mapGetters } from 'vuex';
import siteInfo from '@/Scripts/lib/helper/siteInfo.js';
import { eventBus } from '@/Scripts/lib/helper/eventBus.js';

export default {
  data: function () {
    return {
      loading: false,
      infoModal: false
    };
  },
  mixins: [siteInfo],
  components: {
    ButtonComponent
  },
  props: {
    addedToBagOverlay: {
      type: Boolean,
      default: false
    },
    hideLogos: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    },
    fontColorOverride: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      cart: state => state.bag.cart,
      ShippingTimeEstimate: state => state.siteInfo.usp.ShippingTimeEstimate
    }),
    ...mapGetters({
      cartItems: 'bag/cartItems',
      cartCount: 'bag/cartCount',
      calculateShipping: 'bag/calculateShipping',
      calculateTotal: 'bag/calculateTotal',
      calculateTotalExclShipping: 'bag/calculateTotalExclShipping'
    }),
    outputShipping () {
      if (this.calculateShipping === 'undefined undefined') {
        return '';
      }
      return this.calculateShipping;
    },
    outputTotal () {
      if (this.calculateTotal === 'undefined undefined') {
        return '';
      }
      return this.calculateTotal;
    },
    outputTotalExclShipping () {
      if (this.calculateTotalExclShipping === 'undefined undefined') {
        return '';
      }
      return this.calculateTotalExclShipping;
    },
    style () {
      if (this.themeColor) {
        return {
          backgroundColor: this.themeColor,
          color: this.fontColorOverride
        };
      }
      return {};
    },
    bagUrl () {
      return `${this.links.ShoppingBagPage}?returnurl=${window.location.href}&count=${this.cartItems.length}`;
    }
  },
  methods: {

    openBag () {
      if (this.links.ShoppingBagPage) {
        const url = `${this.links.ShoppingBagPage}?returnurl=${window.location.href}&count=${this.cartItems.length}`;
        window.location.href = url;
      } else {
        eventBus.$emit('openBag');
        setTimeout(() => {
          this.$emit('close');
        }, 500);
      }
    }
  }

};
</script>

<style lang="scss">
@import "@/scss/defaults.scss";
.addedtobag-summary {
  .-small-gap {
    grid-column-gap: 18px;
  }
  .-devider {
    margin: 12px 0;
    border-bottom: 1px solid $gray-light;
    @include media-breakpoint-up(md) {
      margin: 18px 0;
    }
  }
}
</style>
